import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface ProjectUserIconProps {
  color?: string;
  style?: React.CSSProperties;
  height?: string;
  width?: string;
}

export default function ProjectUserIcon({
  color = RoutalPalette.secondary20,
  style = {},
  height = `13px`,
  width = `13px`,
}: ProjectUserIconProps) {
  return (
    <SvgIcon viewBox="0 0 13 13" style={{ fill: `none`, height: height, width: width, ...style }}>
      <g>
        <path
          d="M7.06227 7.88431C8.77042 7.88431 10.2125 9.22215 10.2125 10.2364C10.2125 10.8935 8.76117 11.5984 7.06227 11.5984C5.35412 11.5984 3.91211 10.7563 3.91211 10.0694C3.91211 9.05512 5.36295 7.88431 7.06227 7.88431ZM7.06227 3.4707C8.21925 3.4707 9.14669 4.34846 9.14669 5.44347C9.14669 6.53847 8.21925 7.41623 7.06227 7.41623C5.90528 7.41623 4.97785 6.53847 4.97785 5.44347C4.97785 4.34846 5.90528 3.4707 7.06227 3.4707Z"
          stroke={color}
        />
        <circle cx="6.99097" cy="6.08667" r="5.50854" stroke={color} />
      </g>
    </SvgIcon>
  );
}
